/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState, useEffect, Suspense, lazy } from "react";
import { isMobileDevice, isMobileOrTablet, isHighResolutionScreen, isDBAApprovedState } from "../../components/Utils";
import Banner from "../../components/Banner";
import Navigation from "../../components/NavigationBar/NavigationBar";

const Footer = lazy(() => import("../../components/Footer"));

function Home() {
    const [isMobile, setIsMobile] = useState(isMobileDevice());
    const [isHighScreenDisplay, setIsHighScreenDisplay] = useState(isHighResolutionScreen());
    const [isApprovedState, setIsApprovedState] = useState(true);
    const [showOtherComponents, setShowOtherComponents] = useState(false);

    const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.body.offsetHeight;
        const scrollPosition =
            window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop;
        const maxScroll = documentHeight - windowHeight;
        const percentage = (scrollPosition / maxScroll) * 100;

        if (percentage > 0) {
            setShowOtherComponents(true);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        function handleResize() {
            setIsMobile(isMobileDevice());
            setIsHighScreenDisplay(isHighResolutionScreen());
        }

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const dbaApproved = await isDBAApprovedState();
                setIsApprovedState(dbaApproved);
            } catch (error) {
                // Handle error
                console.error("Error fetching data:", error);
                setIsApprovedState(false); // Set state accordingly
            }
        };

        fetchData();
    }, [isApprovedState]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    return (
        <div>
            <Navigation />
            <Banner
                isMobile={isMobile}
                isHighScreenDisplay={isHighScreenDisplay}
                showLearnMoreBtn={true}
                isApprovedState={isApprovedState}
            />
         
                <Suspense fallback={<div />}>
                    <Footer />
                </Suspense>
         
        </div>
    )
}
export default Home